import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { ItemType } from 'src/components/common/field/TypeCustom';
import { FieldTableType } from 'src/components/common/table/TypeCustom';
import { getField } from 'src/common/helper';

const listColRowSpan = [
  'day',
  'sales',
  'opsales',
  'cash',
  'card1',
  'card2',
  'loan',
  'advance',
  'total'
];

type RecordItemProps = {
  item: any;
  fields: FieldTableType[];
  rowSpan?: number;
  summary?: any,
  statuses?: ItemType[];
  index?: number;
  onClickRow?: (data: any | undefined) => void;
  onClickBtnEdit?: (data: any | undefined) => void;
  onClickBtnDelete?: (data: any | undefined) => void;
};

const RecordItem: React.FC<RecordItemProps> = (props) => {

  const handleClickRow = (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => {
    const target = event.target as HTMLElement;
    const isDropdownOrButton =
      target.closest('td')?.querySelector('.MuiOutlinedInput-root') ||
      target.closest('.MuiPopover-root') ||
      target.closest('td')?.querySelector('.MuiButtonBase-root');

    if (!isDropdownOrButton) {
      props.onClickRow?.(props.item);
    }
  };

  const getDataItem = (field: string) => {
    return props.item[field] && props.item[field] !== '0' ? props.item[field] : '-';
  };

  return (
    <TableRow
      hover
      onClick={handleClickRow}
      key={props.item.id}
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
        '& .MuiTableCell-root.MuiTableCell-body': {
          p: '4px 10px',
          borderBottom: '1px solid #F3F3F3',
          fontSize: '14px',
          fontWeight: 400,
          lineHeight: '14.4px'
        },
        height: '48px',
      }}
    >
      {props.fields.map((field, index: number) => (
        (getField(props.item, 'dayfirst') === 1
          || (getField(props.item, 'dayfirst', 0) === 0
            && !listColRowSpan.includes(field.field))) && (
          <TableCell
            key={index}
            component='td'
            scope='row'
            sx={{ cursor: 'pointer' }}
            rowSpan={listColRowSpan.includes(field.field) ? props.rowSpan : 1}
          >
            <Typography
              sx={{
                whiteSpace: 'pre-wrap',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '14.4px'
              }}>
              {field.field === 'index' ? props.index : ((field.isPrice ? '¥' : '') + getDataItem(field.field))}
            </Typography>
          </TableCell>
        )
      ))}
    </TableRow >
  );
};

export default RecordItem;
